import { render } from "./Avatar.vue?vue&type=template&id=0d5a90db"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
script.render = render

export default script